'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import dutchflag from './icon-de.png';
import engflag from './icon-eng.png';
import { useNavigate } from 'react-router-dom';
import { Additem, Warning2 } from 'iconsax-react';
import { useAppDispatch, useAppSelector } from '../../../application/store/useStore';
import { useCompanyContext } from '../../../application/context/CompanyContext';
import { useEffect, useState, useMemo } from 'react';
import { deleteProposalsAsync, getDocumentProcessStatusAsync, getProposalsAsync } from '../../../application/features/proposal/proposalThunk';
import { getProposalDocsAsync } from '../../../application/features/proposalDocument/proposalDocumentThunk';
import { initiateChatAsync } from '../../../application/features/chat/chatThunk';
import { useTranslation } from 'react-i18next';
import { ProposalProcessStatus } from '../../../application/common/enums/proposal-process-status';
import { alpha, Box, Button, IconButton, Tooltip, Typography, useTheme, TextField, InputAdornment, Chip } from '@mui/material';
import { getGridDateOperators } from '@mui/x-data-grid';
import { Search as SearchIcon } from '@mui/icons-material';
import { NewProposalDialog } from './new-proposal-dilaog';
import { toast } from 'react-toastify';
import { Chat, Delete } from 'react-iconly';
import { ProposalDocumentPopUp } from './view-proposal-docs';
import { DeleteDialog } from './delete-proposal-dialog';
import { CustomGrid } from '../../../ui/components/common/dataGrid';
import ImageLoader from '../../../ui/components/common/ImageLoader';
import { formatDMY } from '../../../infrastructure/helpers';
const flagMap = {
    dutch: dutchflag,
    english: engflag
};
const Proposals = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { selectedCompanyId } = useCompanyContext();
    const { allProposals, proposal } = useAppSelector((state) => state.proposal);
    const { allProposalDocs } = useAppSelector((state) => state.proposalDocs);
    const { currentUser } = useAppSelector((state) => state.auth);
    const { allUsers } = useAppSelector((state) => state.users);
    console.log('Proposals Component - selectedCompanyId:', selectedCompanyId);
    console.log('Proposals Component - allProposals count:', allProposals?.length);
    console.log('Current User Role:', currentUser?.role);
    const [toastMessage, setToastMessage] = useState('');
    const [selectedProposalName, setSelectedProposalName] = useState(null);
    const [selectedProposalId, setSelectedProposalId] = useState(null);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [selectedProposalsToDelete, setSelectedProposalsToDelete] = useState([]);
    const [proposals, setProposals] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const selectedProposal = proposals.find((proposal) => proposal.id === selectedProposalId);
    const [loading, setLoading] = useState(true);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [newProposalDialog, setnewProposalDialog] = useState(false);
    const [viewProposalDocumentsDialog, setviewProposalDocumentsDialog] = useState(false);
    const [files, setFiles] = useState([]);
    const resetFiles = () => setFiles([]);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [sortModel, setSortModel] = useState([
        { field: 'createdDate', sort: 'desc' }
    ]);
    const openDeleteDialog = (proposal) => {
        if (proposal) {
            // Single delete from action button
            setSelectedProposalsToDelete([proposal]);
        }
        else {
            // Bulk delete from selection
            const selected = (allProposals || []).filter((p) => rowSelectionModel.includes(p.id));
            setSelectedProposalsToDelete(selected);
        }
        setIsDeleteDialogOpen(true);
    };
    const closeDeleteDialog = () => {
        setSelectedProposalId(null);
        setSelectedProposalName(null);
        setIsDeleteDialogOpen(false);
    };
    const closeNewProposalDialog = () => {
        setnewProposalDialog(false);
    };
    const closeViewProposalDocumentsDialog = () => {
        setviewProposalDocumentsDialog(false);
    };
    const columns = [
        {
            field: 'createdDate',
            headerName: t('createdOn'),
            flex: 1,
            minWidth: 150,
            filterOperators: getGridDateOperators().filter((operator) => operator.value === 'is'),
            renderCell: (params) => {
                return _jsx("span", { children: formatDMY(params.value) });
            }
        },
        {
            field: 'projectName',
            headerName: t('projectName'),
            flex: 1,
            // sortable: true,
            minWidth: 240
        },
        {
            field: 'projectCategory',
            headerName: t('projectCategory'),
            flex: 1,
            minWidth: 150
        },
        {
            field: 'projectSubCategory',
            headerName: t('projectSubcategory'),
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                if (!params.value)
                    return _jsx("div", {});
                // Handle array case
                if (Array.isArray(params.value)) {
                    return _jsx("div", { children: params.value.join(', ') });
                }
                // Try to parse as JSON first
                if (typeof params.value === 'string') {
                    try {
                        const parsed = JSON.parse(params.value);
                        if (Array.isArray(parsed) && parsed.length > 0) {
                            return _jsx("div", { children: parsed.join(', ') });
                        }
                    }
                    catch {
                        // JSON parsing failed, treat as comma-separated string
                    }
                    // Fall back to treating as comma-separated string
                    return _jsx("div", { children: params.value });
                }
                return _jsx("div", {});
            }
        },
        {
            field: 'clientName',
            headerName: t('client'),
            flex: 1,
            // sortable: true,
            renderCell: (params) => _jsx("div", { style: { color: '#242424' }, children: params.value }),
            minWidth: 200
        },
        // {
        //   field: 'industry',
        //   headerName: t('industry') as string,
        //   flex: 1,
        //   sortable: true,
        //   minWidth: 200
        // },
        {
            field: 'documentsProcess',
            headerName: t('proposalStatus'),
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                const status = params.value;
                const statusVal = status;
                let label = 'Unknown';
                let textColor = theme.palette.info.main;
                let bgColor = alpha(theme.palette.info.main, 0.1);
                if (status === ProposalProcessStatus.DocumentProcessed ||
                    status === 'DocumentProcessed' ||
                    statusVal === 1) {
                    label = 'Available';
                    textColor = theme.palette.success.main;
                    bgColor = alpha(theme.palette.success.main, 0.1);
                }
                else if (status === ProposalProcessStatus.DocumentProcessing ||
                    status === 'DocumentProcessing' ||
                    statusVal === 0) {
                    label = 'Loading';
                    textColor = theme.palette.warning.main;
                    bgColor = alpha(theme.palette.warning.main, 0.1);
                }
                else if (status === ProposalProcessStatus.Failed ||
                    status === 'Failed' ||
                    statusVal === 2) {
                    label = 'Error';
                    textColor = theme.palette.error.main;
                    bgColor = alpha(theme.palette.error.main, 0.1);
                }
                return (_jsx(Chip, { label: label, size: 'small', sx: {
                        ":hover": {
                            backgroundColor: bgColor,
                            color: textColor,
                        },
                        backgroundColor: bgColor,
                        color: textColor,
                        borderRadius: 3,
                        height: '24px',
                        fontWeight: 600
                    } }));
            }
        },
        {
            field: 'clientSubCategory',
            headerName: t('clientSubcategory'),
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                if (!params.value)
                    return _jsx("div", {});
                // Handle array case
                if (Array.isArray(params.value)) {
                    return _jsx("div", { children: params.value.join(', ') });
                }
                // Try to parse as JSON first
                if (typeof params.value === 'string') {
                    try {
                        const parsed = JSON.parse(params.value);
                        if (Array.isArray(parsed) && parsed.length > 0) {
                            return _jsx("div", { children: parsed.join(', ') });
                        }
                    }
                    catch {
                        // JSON parsing failed, treat as comma-separated string
                    }
                    // Fall back to treating as comma-separated string
                    return _jsx("div", { children: params.value });
                }
                return _jsx("div", {});
            }
        },
        // {
        //   field: 'status',
        //   headerName: t('status') as string,
        //   flex: 1,
        //   // sortable: true,
        //   minWidth: 150
        // },
        // {
        //   field: 'progress',
        //   headerName: t('progress') as string,
        //   flex: 1,
        //   // sortable: true,
        //   minWidth: 150,
        //   renderCell: (params) => <div>{params.value}%</div>
        // },
        {
            field: 'companyName',
            headerName: t('company'),
            flex: 1,
            minWidth: 180,
            renderCell: (params) => _jsx("div", { style: { color: '#242424' }, children: params.value || 'N/A' })
        },
        {
            field: 'language',
            headerName: t('language'),
            flex: 1,
            // sortable: true,
            minWidth: 100,
            renderCell: (params) => (_jsx("div", { style: { display: 'flex', alignItems: 'center', height: '100%' }, children: _jsx("img", { src: flagMap[params.value?.toLowerCase()] || '', alt: `${params.value} flag`, width: 24, style: { marginRight: '8px' } }) }))
        },
        {
            field: 'proposalDocs',
            headerName: t('files'),
            flex: 1,
            // sortable: true,
            minWidth: 110,
            renderCell: (params) => {
                // Debug: Log the proposal data to check file count
                const row = params.row;
                console.log('Full proposal row:', row);
                // Check various possible field names
                const possibleCount = row.proposalDocs ||
                    row.proposalDocsCount ||
                    row.documentsCount ||
                    row.fileCount ||
                    row.totalDocuments ||
                    0;
                console.log('File count for', row.projectName, ':', possibleCount);
                const fileCount = possibleCount;
                return (_jsx(Button, { size: 'small', sx: {
                        borderRadius: '500px',
                        minWidth: '24px',
                        backgroundColor: alpha(theme.palette.grey[500], 0.16),
                        color: theme.palette.text.primary,
                        boxShadow: 'none'
                    }, onClick: (event) => { event.stopPropagation(); viewProposalDocs(params.row.id, params.row.projectName); }, variant: 'contained', children: _jsx(Typography, { variant: 'body2', fontWeight: 400, children: fileCount }) }));
            }
        },
        {
            field: 'actions',
            headerName: '',
            flex: 1,
            align: 'center',
            // sortable: false,
            minWidth: 170,
            renderCell: (params) => {
                // Helper function to check document process status (handles both string and enum)
                const isProcessing = params.row.documentsProcess === ProposalProcessStatus.DocumentProcessing ||
                    params.row.documentsProcess === 'DocumentProcessing' ||
                    params.row.documentsProcess === 0;
                const isProcessed = params.row.documentsProcess === ProposalProcessStatus.DocumentProcessed ||
                    params.row.documentsProcess === 'DocumentProcessed' ||
                    params.row.documentsProcess === 1;
                const isFailed = params.row.documentsProcess === ProposalProcessStatus.Failed ||
                    params.row.documentsProcess === 'Failed' ||
                    params.row.documentsProcess === 2;
                // Check if status contains "Generating Answer"
                const isGeneratingAnswer = params.row.status && params.row.status.toLowerCase().includes('generating answer');
                // Check if proposal was created more than 25 seconds ago
                const createdDate = new Date(params.row.createdDate);
                const now = new Date();
                const timeDiffSeconds = (now.getTime() - createdDate.getTime()) / 1000;
                const showChatAfter25Sec = timeDiffSeconds > 60;
                // Show chat icon if: processed OR (after 25 sec OR generating answer)
                const shouldShowChatIcon = isProcessed || (isProcessing && isGeneratingAnswer);
                return (_jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        width: '100%',
                        gap: '12px'
                    }, children: [isProcessing && (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, onClick: (e) => e.stopPropagation(), children: _jsx(ImageLoader, { height: '28px', width: '28px' }) })), isFailed && (_jsx(Tooltip, { title: params.row.statusMessage ? params.row.statusMessage : t('attemptFailed'), children: _jsx(IconButton, { size: 'small', onClick: (e) => e.stopPropagation(), children: _jsx(Warning2, { color: 'red' }) }) })), shouldShowChatIcon && !isFailed && (_jsx(IconButton, { size: 'small', onClick: (event) => { event.stopPropagation(); chatSetup(params.row.id.toString()); }, children: _jsx(Chat, { set: 'curved', primaryColor: theme.palette.primary.main }) })), !isProcessing && (_jsx(IconButton, { size: 'small', onClick: (event) => {
                                event.stopPropagation();
                                deleteProposal(params.row);
                            }, children: _jsx(Delete, { set: 'curved', primaryColor: theme.palette.error.main }) }))] }));
            }
        }
    ];
    useEffect(() => {
        console.log('=== Proposal Screen - Fetch Triggered ===');
        console.log('Selected Company ID:', selectedCompanyId);
        // Don't fetch if no company is selected
        if (!selectedCompanyId) {
            console.log('No company selected, waiting...');
            return;
        }
        console.log('Fetching proposals for company:', selectedCompanyId);
        setLoading(true);
        dispatch(getProposalsAsync(selectedCompanyId))
            .unwrap()
            .then((data) => {
            console.log('Proposals received:', data?.length || 0);
            console.log('First proposal company:', data?.[0]?.companyId);
        })
            .finally(() => setLoading(false));
    }, [dispatch, selectedCompanyId]);
    useEffect(() => {
        // Initial status check
        dispatch(getDocumentProcessStatusAsync({ background: true, companyId: selectedCompanyId || undefined }));
        // Poll every 60 seconds to check document processing status
        const intervalId = setInterval(() => {
            dispatch(getDocumentProcessStatusAsync({
                background: true,
                companyId: selectedCompanyId || undefined
            }));
        }, 60000);
        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [dispatch, selectedCompanyId]);
    useEffect(() => {
        if (toastMessage) {
            setTimeout(() => setToastMessage(''), 3000);
        }
    }, [toastMessage]);
    const viewProposalDocs = (proposalId, proposalName) => {
        setSelectedProposalId(proposalId);
        console.log(proposalName);
        setSelectedProposalName(proposalName);
        setviewProposalDocumentsDialog(true);
        dispatch(getProposalDocsAsync(proposalId));
    };
    const chatSetup = (proposalId) => {
        setLoading(true);
        dispatch(initiateChatAsync(proposalId))
            .unwrap()
            .then((response) => {
            if (response) {
                navigate(`/chat?id=${proposalId}`);
                setLoading(false);
            }
        });
    };
    const handleDelete = () => {
        if (selectedProposalsToDelete.length > 0) {
            const ids = selectedProposalsToDelete.map((p) => p.id);
            dispatch(deleteProposalsAsync(ids))
                .unwrap()
                .then(() => {
                toast.success(ids.length === 1 ? 'Proposal has been deleted.' : 'Proposals have been deleted.');
                closeDeleteDialog();
                // Update selection model by removing deleted IDs
                setRowSelectionModel((prev) => prev.filter((id) => !ids.includes(id)));
            })
                .catch(() => {
                toast.error('Failed to delete proposal(s).');
            });
        }
    };
    const handleRemoveItemFromDeleteDialog = (id) => {
        setSelectedProposalsToDelete((prev) => prev.filter((p) => p.id !== id));
    };
    const deleteProposal = (proposal) => {
        openDeleteDialog(proposal);
    };
    const defaultSortingModel = [{ field: 'createdDate', sort: 'desc' }];
    // Get user's assigned company IDs for Admin/User role filtering
    const userAssignedCompanyIds = useMemo(() => {
        if (!currentUser || currentUser.role === 'SuperAdmin')
            return null;
        const currentUserDetails = allUsers?.find((u) => u.email === currentUser.email);
        return currentUserDetails?.companyIds || [];
    }, [currentUser, allUsers]);
    // Filter proposals based on user role, selected company AND search term
    const filteredProposals = (allProposals || []).filter((proposal) => {
        // FIRST: Role-based filtering for Admin and User
        if (currentUser?.role !== 'SuperAdmin' && userAssignedCompanyIds) {
            // Admin and User can only see proposals from their assigned companies
            if (proposal.companyId && !userAssignedCompanyIds.includes(proposal.companyId)) {
                console.log('Role filter: Hiding proposal from non-assigned company:', proposal.projectName, 'CompanyId:', proposal.companyId);
                return false;
            }
        }
        // SECOND: Filter by selected company (client-side safety filter)
        if (selectedCompanyId && selectedCompanyId !== 'ALL') {
            // Only show proposals that match the selected company
            if (proposal.companyId !== selectedCompanyId) {
                console.log('Company filter: Filtering out proposal:', proposal.projectName, 'Company:', proposal.companyName, 'CompanyId:', proposal.companyId);
                return false;
            }
        }
        // SECOND: Filter by search term
        if (!searchTerm.trim())
            return true;
        const searchLower = searchTerm.toLowerCase();
        // Parse project subcategories if they are strings
        let projectSubCategories = '';
        const projectSubCat = proposal.projectSubCategory;
        if (Array.isArray(projectSubCat)) {
            projectSubCategories = projectSubCat.join(', ').toLowerCase();
        }
        else if (typeof projectSubCat === 'string' && projectSubCat.trim() !== '') {
            try {
                const parsed = JSON.parse(projectSubCat);
                projectSubCategories = Array.isArray(parsed)
                    ? parsed.join(', ').toLowerCase()
                    : projectSubCat.toLowerCase();
            }
            catch {
                projectSubCategories = projectSubCat.toLowerCase();
            }
        }
        // Parse client subcategories if they are strings
        let clientSubCategories = '';
        const clientSubCat = proposal.clientSubCategory;
        if (Array.isArray(clientSubCat)) {
            clientSubCategories = clientSubCat.join(', ').toLowerCase();
        }
        else if (typeof clientSubCat === 'string' && clientSubCat.trim() !== '') {
            try {
                const parsed = JSON.parse(clientSubCat);
                clientSubCategories = Array.isArray(parsed)
                    ? parsed.join(', ').toLowerCase()
                    : clientSubCat.toLowerCase();
            }
            catch {
                clientSubCategories = clientSubCat.toLowerCase();
            }
        }
        return (proposal.projectName?.toLowerCase().includes(searchLower) ||
            proposal.clientName?.toLowerCase().includes(searchLower) ||
            proposal.projectCategory?.toLowerCase().includes(searchLower) ||
            projectSubCategories.includes(searchLower) ||
            proposal.clientCategory?.toLowerCase().includes(searchLower) ||
            clientSubCategories.includes(searchLower) ||
            proposal.industry?.toLowerCase().includes(searchLower) ||
            proposal.language?.toLowerCase().includes(searchLower));
    });
    // Helper to check status types safely
    const checkStatus = (row, type) => {
        const status = row.documentsProcess;
        const statusVal = status;
        if (type === 'processing') {
            return (status === ProposalProcessStatus.DocumentProcessing ||
                statusVal === 'DocumentProcessing' ||
                statusVal === 0);
        }
        if (type === 'failed') {
            return (status === ProposalProcessStatus.Failed ||
                statusVal === 'Failed' ||
                statusVal === 2);
        }
        return false;
    };
    // Only visually disable (fade/block pointer events via CSS) if Processing.
    // We DO NOT visually disable Failed items, so that the Delete button remains clickable.
    const isRowVisualDisabled = (row) => checkStatus(row, 'processing');
    const handleRowClick = (params) => {
        // Block navigation for both Processing and Failed states
        if (checkStatus(params.row, 'processing') || checkStatus(params.row, 'failed'))
            return;
        chatSetup(params.row.id.toString());
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1, children: [_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start", py: 1, children: [_jsx(Typography, { variant: 'h4', fontWeight: 600, children: t('proposals') }), _jsx(Typography, { variant: 'caption', color: 'text.secondary', children: selectedCompanyId
                                            ? `Showing ${filteredProposals.length} proposals for selected company`
                                            : 'No company selected' })] }), _jsx(Button, { variant: 'contained', startIcon: _jsx(Additem, {}), color: 'primary', size: 'large', onClick: () => {
                                    if (!selectedCompanyId || selectedCompanyId === 'ALL') {
                                        toast.warning(t('companyRequired') || 'Please select a company before creating a proposal');
                                        return;
                                    }
                                    setnewProposalDialog(true);
                                }, children: t('newProposal') })] }), rowSelectionModel.length === 0 && (_jsx(Box, { display: 'flex', justifyContent: 'flex-start', children: _jsx(TextField, { placeholder: t('searchProposals') ||
                                'Search by project name, client, category, subcategory, or language...', value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), sx: { width: { xs: '100%', sm: 400, md: 450 }, maxWidth: '100%' }, size: 'small', InputProps: {
                                startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchIcon, {}) }))
                            } }) })), rowSelectionModel.length > 0 && (_jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: "space-between", children: [_jsxs(Typography, { variant: 'h5', children: [rowSelectionModel.length, " Selected"] }), _jsx(Button, { variant: 'outlined', color: 'error', startIcon: _jsx(Delete, { set: 'curved' }), onClick: () => openDeleteDialog(), sx: {
                                    textTransform: 'none',
                                    borderColor: theme.palette.error.main,
                                    color: theme.palette.error.main,
                                    '&:hover': {
                                        backgroundColor: alpha(theme.palette.error.main, 0.04)
                                    }
                                }, children: t('deleteAll') || 'Delete All' })] })), searchTerm.trim() && (_jsx(Typography, { variant: 'body2', color: 'text.secondary', children: filteredProposals.length > 0
                            ? `Found ${filteredProposals.length} ${filteredProposals.length === 1 ? 'proposal' : 'proposals'} matching "${searchTerm}"`
                            : `No proposals found matching "${searchTerm}"` }))] }), _jsx(Box, { width: '100%', mt: 1, children: _jsx(CustomGrid, { rows: filteredProposals, columns: columns, sortModel: sortModel, onSortModelChange: setSortModel, onRowClick: handleRowClick, getRowClassName: (params) => isRowVisualDisabled(params.row) ? 'row-disabled' : '', checkboxSelection: true, disableRowSelectionOnClick: true, rowSelectionModel: rowSelectionModel, onRowSelectionModelChange: setRowSelectionModel, sx: {
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer'
                        }
                    } }) }), _jsx(NewProposalDialog, { openProposalDialog: newProposalDialog, onClose: closeNewProposalDialog }), _jsx(DeleteDialog, { open: isDeleteDialogOpen, proposals: selectedProposalsToDelete, onClose: closeDeleteDialog, onDelete: handleDelete, onRemoveItem: handleRemoveItemFromDeleteDialog }), _jsx(ProposalDocumentPopUp, { files: allProposalDocs ? allProposalDocs : [], openProposalDocumentDialog: viewProposalDocumentsDialog, onClose: closeViewProposalDocumentsDialog, proposalName: selectedProposalName ? selectedProposalName : '' })] }));
};
export default Proposals;
